import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/fin_productos";

const getProductos = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};

const createProducto = async (data, usuario) => {
  const response = await axios.post(
    `${baseUrl}${endpoint}`,
    data,
    {
      headers: { usuario }
    }
  );
  return response.data;
};

const updateProducto = async (id, data, usuario) => {
  const response = await axios.put(
    `${baseUrl}${endpoint}/${id}`,
    data,
    {
      headers: {
        usuario
      }
    }
  );
  return response.data;
};

const deleteProducto = async (id, usuario) => {
  const response = await axios.delete(
    `${baseUrl}${endpoint}/${id}`,
    {
      headers: {
        usuario
      }
    }
  );
  return response.data;
};

export { getProductos, createProducto, updateProducto, deleteProducto };